<style>

.container{
  display: grid;
  grid-template-columns: 50px auto 50px auto;
  font-size: 40px;
  text-align: center;
}

.hour-plus{ grid-column: 1; grid-row: 1; }
.hour{ grid-column: 1; grid-row: 2; }
.hour-minus{ grid-column: 1; grid-row: 3; }

.colon{ grid-column: 2; grid-row: 2; }

.min-plus{ grid-column: 3; grid-row: 1; }
.min{ grid-column: 3; grid-row: 2; }
.min-minus{ grid-column: 3; grid-row: 3; }

.period-plus{ grid-column: 4; grid-row: 1; }
.period{ grid-column: 4; grid-row: 2; }
.period-minus{ grid-column: 4; grid-row: 3; }

/* extra styling, if need be */
/* .hour-plus, .hour-minus, .min-plus, .min-minus, .period-plus, .period-minus {
  border: 1px black solid;
} */

</style>

<!-- 
[+] [+] [+]
[n]:[n] [am/pm]
[-] [-] [-] 
-->

<div class="container">
  
  <div class="hour-plus" on:click="{ addHour }">+</div>
  <div class="hour">{hour}</div>
  <div class="hour-minus" on:click="{ subHour }">-</div>
  
  <div class="colon">:</div>
  
  <div class="min-plus" on:click="{ addMinute }">+</div>
  <div class="min">{ correctMinute(minute) }</div>
  <div class="min-minus" on:click="{ subMinute }">-</div>
  
  <div class="period-plus" on:click="{ invertPeriod }">+</div>
  <div class="period">{period}</div>
  <div class="period-minus" on:click="{ invertPeriod }">-</div>
  
</div>

<script>

export let time = "16:20:00";

let hour = 0;
let minute = 0;
let period = "";

$:{
  if (time) {
    parseTime(time)
  }
}


function parseTime(time) {
  let date = new Date("1976-02-29 " + time);
  
  period = "am";
  
  hour = date.getHours();
  if (hour > 12) {
    period = "pm";
    hour-=12;
  } else if (hour == 12) {
    period = "pm";
  }
  minute = date.getMinutes();
  assembleTime();
}


function addHour() {
  hour++;
  
  if (hour > 12) {
    hour = 1;
  }
  assembleTime();
}


function subHour() {
  hour--;
  
  if (hour < 1) {
    hour = 12;
  }
  assembleTime();
}


function addMinute() {
  minute += 5;
  
  if (minute > 55) {
    minute = 0;
  }
  assembleTime();
}


function subMinute() {
  minute -= 5;
  
  if (minute < 0) {
    minute = 55;
  }
  assembleTime();
}


function correctMinute(minute) {
  if (minute < 10) {
    return `0${ minute }`;
  }
  return minute;
}


function invertPeriod() {
  period = period == "pm" ? "am" : "pm";
  assembleTime();
}


function assembleTime() {
  let thour = hour;
  let tmin = minute;
  
  if (period == "pm" && hour != 12) {
    thour = hour + 12;
  }
  if (minute < 10) {
    tmin = `0${ minute }`;
  }
  
  time = `${thour}:${tmin}:00`;
}
</script>